<div class="container">
  <div class="row no-gutters">
    <div class="col-12">

      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblEditParts</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
        
      </div>

      
      <form [formGroup]="editPartForm" (ngSubmit)="onSubmit()" *ngIf="partList?.partLists">
        <div class="scrollbar">
          <div class="card-content">
    
              <div class="row">
                <div class="col-md-6 af-form-group">
                  <!-- PartNumber -->
                  <label for="service" translate>lblPartNumber</label>
                  <div class='lbl-info'>
                    <input formControlName="partNumber" class="form-control mb-2" readonly
                      placeholder="Enter Part Number"
                      [ngClass]="{'is-invalid': cpf.partNumber.invalid && cpf.partNumber.touched}">
                    <div *ngIf="cpf.partNumber.touched && (cpf.partNumber.errors?.required)"
                      class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                        aria-hidden="true"></em>
                      lblPartNumbeRrequired
                      <span *ngIf="cpf.partNumber.errors?.maxlength" translate>
                        lbl100CharacterAllow</span>
                    </div>
                  </div>
                </div>

                <!-- CostType drop down -->
                <div class="col-md-6 af-form-group" [hidden]='true'>
                  <label for="service" translate>lblCostType</label>
                  <div class='lbl-info'>
                    <select class="form-control" formControlName="costType" readonly
                      [ngClass]="{'is-invalid': cpf.costType.invalid && cpf.costType.touched}">
                      <option selected disabled [ngValue]="null" translate>lblSelectCostType
                      </option>
                      <option *ngFor="let costType of costTypeData" [ngValue]="costType.name" disabled="disabled">
                        {{costType.name}}
                      </option>
                    </select>
                    <div *ngIf="cpf.costType.invalid && (cpf.costType.dirty || cpf.costType.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.costType.errors.required"><span translate>lblCostTypeRequired</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Description -->
                <div class="w-100 px-0" *ngIf="t">
                  <div *ngFor="let ticket of t.controls; let i = index">
                    <div [formGroup]="ticket">
                      <div class="col-3 af-form-group">
                        <label for="name"><span translate>lblDescription</span><span> in
                            {{languageList[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class="lbl-info">
                          <input formControlName="name" class="form-control mb-2" maxlength="150"
                          [ngClass]="{'is-invalid': cpf.service.invalid && cpf.service.touched}">
                          <div *ngIf="cpf.service.touched && (cpf.service.errors?.required)"
                            class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                              lblDescriptionIsRequired
                          </div>
                        </div>
                      </div>

                      <div class="col-3 af-form-group" style="display: none;">
                        <label for="languageId" translate>Language Id</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                            maxlength="30">
                        </div>
                      </div>

                      <div class="col-3 af-form-group">
                        <label for="description"><span translate>lblComment</span><span> in
                            {{languageList[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <input formControlName="description" class="form-control mb-2" maxlength="150"
                          [ngClass]="{'is-invalid': cpf.service.invalid && cpf.service.touched}">
                          <div *ngIf="cpf.service.touched && (cpf.service.errors?.required)"
                            class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                              lblCommentRequired
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
               

                <!-- UnitPrice -->
                <div class="col-md-6 af-form-group">
                  <label for="service" translate>lblUnitPrice<strong class="mlt6 required"> * </strong></label>
                  <div class='lbl-info'>
                    <input type="text" formControlName="unitPrice" class="form-control" placeholder="Enter unit price"
                      pattern="^[\d,.\s]+$" required (blur)="onBlur($event)"
                      [ngModel]="partList.partLists.unitPrice | number:'1.2-2'"
                      [ngClass]="{'is-invalid': cpf.unitPrice.invalid && cpf.unitPrice.touched}" maxlength="10">
                    <div *ngIf="cpf.unitPrice.invalid && (cpf.unitPrice.dirty || cpf.unitPrice.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.unitPrice.errors.required"><span translate>lblUnitPriceRequired</span></div>
                      <div *ngIf="cpf.unitPrice.errors.pattern"><span translate>lblProperValue</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class=" col-md-6 af-form-group">
                    <label for="template-make" translate>lblMake<strong class="mlt6 required">
                        *</strong> </label>
                    <div class='lbl-info'>
                      <ng-select formControlName="makeCode" placeholder="{{ 'lblSelectMake' | translate }}" required (change)="OnMakeChange()"
                        [(ngModel)]="makeCode" [ngClass]="{'ng-select-is-invalid':(cpf.makeCode.invalid  && cpf.makeCode.touched)}">
                        <ng-template ng-header-tmp>
                          <span class="mbold w-66px">Code</span>
                          <span class="mbold" translate>lblMake</span>
                        </ng-template>
    
                        <ng-option *ngFor="let type of makeList" [value]="type.brandCode">
                          <span class="w-66px">{{type.brandCode}}</span>
                          <span class="mx-2 hide-ng-dropdown-panel">-</span>
                          <span>{{type.brandName}}</span>
                        </ng-option>
                      </ng-select>
                      <div *ngIf="(cpf.makeCode.invalid && (cpf.makeCode.dirty || cpf.makeCode.touched))" class="help-block text-danger">
                        <div *ngIf="cpf.makeCode.errors.required"><span translate>lblRequiredMake</span>
                        </div>
                      </div>
                    </div>
    
                  </div>
                  <div class="col-md-6 af-form-group" *ngIf="initialAdditionalLoad">
                        <label for="thisservice" translate>lblAdditionalPart </label>
                        <div class='lbl-info'>
    
                        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="additionalPartsList" 
                        [(ngModel)]="selectedAdditionalItems" [ngModelOptions]="{standalone: true}">
                      </ng-multiselect-dropdown>
                
                        </div>
                    </div>
                    <div class="col-md-6 af-form-group" *ngIf="initialAlternateLoad">
                          <label for="thisservice" translate>lblAlternatePart </label>
                          <div class='lbl-info'>
      
                          <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="alternatePartsList" 
                          [(ngModel)]="selectedAlternateItems" [ngModelOptions]="{standalone: true}">
                        </ng-multiselect-dropdown>
                  
                          </div>
                        </div>
                      <div class="col-md-6 af-form-group" *ngIf="initialReplacementLoad">
                            <label for="thisservice" translate>lblReplacementPart </label>
                            <div class='lbl-info'>
        
                            <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="replacementPartsList" 
                            [(ngModel)]="selectedReplacementItems" [ngModelOptions]="{standalone: true}">
                          </ng-multiselect-dropdown>
                    
                            </div>
                        </div>
               
                      </div>
              <div class="row">
                <div class="col-3 af-form-group">
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
                <div class="col-3 af-form-group">
                    <div class="lbl-info">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="isFixed" formControlName="isFixed">
                        <label class="custom-control-label" for="isFixed" translate>lblIsFixed</label>
                      </div>
                    </div>
                  </div>
                </div>
     
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          
            <div class="d-flex flex-sm-row flex-column justify-content-end">
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align" [disabled]="!editPartForm.valid"
                translate><em class="far fa-save font16 align-top mr-2"></em>lblSaveChanges</button>
              <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
         
        </div>
        
      </form>
    </div>
  </div>
</div>